// Modal store timeouts
export const MODAL_STORE_OPEN_TIMEOUT = 500;
export const MODAL_STORE_HIGHLIGHT_TIMEOUT = 500;

// Index constants
export const FIRST_INDEX = 0;

// Store pagination constants
export const STORE_LIMIT = 50;
export const STORE_OFFSET = 0;

// Column Sizes and UI Constants
export const COLUMN_SIZES = {
  RUN_STATUS: 50,
  STREAM_NAME: 180,
  TRIGGER: 99,
  BUSINESS_DAY: 150,
  DATE: 125,
  MATCHING_RECORDS: 130,
  RECONCILED_RECORDS: 150,
  IN_TRANSIT_RECORDS: 150,
  EXCEPTION_RECORDS: 150,
};

// Header Helper Constants
export const LEGEND_DATA_TAGS = {
  ABORTED: "ABORTED",
  ROLLED_BACK: "ROLLED_BACK",
  ROLLING_BACK: "ROLLING_BACK",
};

export const LEGEND_DATA_COLORS = {
  ABORTED: "#742a2a",
  ROLLED_BACK: "#f6e05e",
  ROLLING_BACK: "#f6ad55",
};

// Pinning Initial State
export const PINNING_INITIAL_STATE = ["pin"];

// Cell Display Constants
export const POPUP_CELL_MIN_WIDTH = "min-w-[264px]";
export const BG_CLASS_NAME = "bg-primary-dark";
export const TEXT_COLOR = "text-[#777f9e]";

// Download/Action Constants
export const DOWNLOAD_CONFIGS = {
  MATCHING_RESULTS: {
    type: "RECONCILIATION_STREAM_MATCHING_RESULTS",
    domain: "Reconciliation",
    label: "Matching Data",
  },
  ROLLBACK_RESULTS: {
    type: "RECONCILIATION_STREAM_ROLLBACK_RESULTS",
    domain: "Reconciliation",
    label: "RollBack Data",
  },
  CORRECTION_LOG: {
    type: "RECONCILIATION_RUN_CORRECTION_LOG",
    domain: "ControlRoom",
    label: "Correction Log",
  },
};

// Table Configuration
export const TABLE_CONFIG = {
  maxHeight: "calc(100dvh - 380px)",
  pinnedRowHeight: 57,
  headerHeight: 37,
  prefix: "ReconciliationRuns",
};

